import {ReportService} from "./reportService";

import * as types from './actionTypes';

export function getReportForDays(number, unit, accessToken) {
  return dispatch => {
    return ReportService.get(number, unit, accessToken)
      .then(result => {
          return dispatch(dispatchReportForDays(result));
      })
      .catch(error => {
        throw(error);
      })
  }
}

function dispatchReportForDays(reportData) {
  return {type: types.REPORT_FOR_DAYS, reportData: reportData}
}

export function storeSelectedNumber(selectednumber) {
    return dispatch => {
        return dispatch(dispatchSelectedNumber(selectednumber));
    }
}

function dispatchSelectedNumber(selectednumber) {
    return {type: types.SELECTED_NUMBER, selectednumber: selectednumber}
}


// WEBPACK FOOTER //
// ./src/service/reportActions.js